    <template>
    <div class="maintenanceStaff_main" :class="{'cn':version == '1'}">
        <div class="maintenanceStaff_top">
            <div class="box btn" @click="linkToFun('/service')">
                <i class="iconfont icon-back"></i><span class="span1">{{$t('App.room_light.text1')}}</span>
            </div>
            <div class="l"></div>
            <div class="box"><span class="span2">{{$t('App.sideBar.text11')}} →</span></div>
            <div class="box">
                <span class="span1">{{$t('App.service.text3')}}</span>
            </div>
        </div>
        <div class="maintenanceStaff_content">
            <div class="toolbar">
                <div class="toolbar_l">
              <!--       <el-select v-model="userId">
                        <el-option
                            v-for="item in userNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select> -->
                    <el-input :placeholder="$t('App.placeholder.text3')" v-model="keywords" @keyup.native="getRepairListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getRepairList()"></i>
                    </el-input>
                </div>
                <div class="toolbar_r">
                    <div class="btn" @click="addMaintenanceStaffFun()">
                        <img :src="img_newMaintenanceStaff">
                        <span>{{$t('App.service.text35')}}</span>
                    </div>
                </div>
            </div>
            <div class="table_box">
                <div class="table_top">
                    <div class="main_top">
                        <div class="main_top_l">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDelRepair(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                    <el-table
                        ref="repairDataList"
                        v-loading="loading.repairDataList"
                        element-loading-background="rgba(0, 0, 0, 0.5)"
                        height="100%"
                        :data="repairDataList">
                        <el-table-column
                            :label="$t('App.lights.text33')"
                            :prop="'index'"
                            align="left"
                            :width="70">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-for="(item) in repairArr"
                            :key="'table_'+item.prop"
                            :prop="item.prop"
                            :label="item.label"
                            :align="item.align?item.align:'center'"
                            :width="item.width"
                            :show-overflow-tooltip="true"
                            :min-width="item.minWidth">
                            </el-table-column>
                            <el-table-column
                            align="center"
                            :min-width="100"
                            :label="$t('App.lights.text6')">
                            <template slot-scope="scope">
                                <span class="btn" @click="editInfo(scope.row)" :title="$t('App.lights.text7')">
                                    <i class="iconfont icon-xinxi"></i>
                                </span>
                                <span class="btn" @click="jurisdictionFun(scope.row)" :title="$t('App.service.text22')">
                                    <i class="iconfont icon-suo"></i>
                                </span>
                                <span class="btn" @click="postDelRepair(scope.row)" :title="$t('App.lights.text1')">
                                    <i class="iconfont icon-delete"></i>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-checkbox-group>
                <div class="pagination_box">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 添加编辑维修人员 -->
        <div class="maintenanceStaff_wrap scrollbar_style" v-show="maintenanceStaffTkShowbg">
            <div class="maintenanceStaff_wrap_bg" @click="maintenanceStaffTkClose()"></div>
            <div class="maintenanceStaff_box" :class="{'maintenanceStaff_tk_show':maintenanceStaffTkShow}">
                <div class="maintenanceStaff_title">
                    <span class="span1">{{maintenanceStaffTkTitle}}</span>
                    <span class="span2" @click="maintenanceStaffTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.name')}}</span>
                        <el-input v-model="maintenanceStaffForm.name" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.number')}}</span>
                        <el-input v-model="maintenanceStaffForm.number" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.phone')}}</span>
                        <el-input v-model="maintenanceStaffForm.phone" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.email')}}</span>
                        <el-input v-model="maintenanceStaffForm.email" placeholder=""></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveMaintenanceStaff()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
        <!-- 维修人员权限 -->
        <div class="jurisdiction_wrap scrollbar_style" v-show="jurisdictionTkShowbg">
            <div class="jurisdiction_wrap_bg" @click="jurisdictionTkClose()"></div>
            <div class="jurisdiction_box" :class="{'jurisdiction_tk_show':jurisdictionTkShow}">
                <div class="jurisdiction_title">
                    <span class="span1">{{$t('App.service.text37')}}</span>
                    <span class="span2" @click="jurisdictionTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="tree_box">
                    <div class="left">
                        <div class="t">
                            <div class="laber">{{$t('App.service.text38')}}</div>
                            <el-checkbox :indeterminate="treeLAllIndeterminate" v-model="treeLAll" @change="treeLAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                        </div>
                        <div class="b1 scrollbar_style">
                            <el-checkbox-group v-model="hotelCheckList" @change="hotelCheckListChange(hotelCheckList,userPermissionList)">
                                <div v-for="item in userPermissionList" :key="item.id" class="hotel_box" :class="{'noShow':item.show}">
                                    <template v-if="item.list">
                                        <div class="li" @click.stop="hotelShowFun(item,item.list.length>0)">
                                            <el-checkbox :label="item.id" :key="item.id" :indeterminate="isIndeterminateTku[item.id]">{{item.name}}</el-checkbox>
                                            <i class="iconfont icon-xiala" v-if="item.list.length>0"></i>
                                        </div>
                                        <el-checkbox-group v-model="buildCheckListData[item.id]" @change="buildCheckListChange(buildCheckListData[item.id],item.id,item.list,item.id)">
                                            <div v-for="build in item.list" :key="build.id" class="build_box" :class="{'noShow':build.show,'noList':!build.list}">
                                                <template v-if="build.list">
                                                    <div class="li" @click.stop="buildShowFun(build,build.list.length>0)">
                                                        <el-checkbox :label="build.id" :key="build.id" :indeterminate="isIndeterminateTkb[item.id+'_'+build.id]">{{build.name}}</el-checkbox>
                                                        <i class="iconfont icon-xiala" v-if="build.list.length>0"></i>
                                                    </div>
                                                    <el-checkbox-group v-model="floorCheckListData[item.id+'_'+build.id]" @change="floorCheckListChange(floorCheckListData[item.id+'_'+build.id],item.id,build.id,build.list,item.id+'_'+build.id)">
                                                        <div v-for="floor in build.list" :key="floor.id" class="floor_box" :class="{'noShow':floor.show,'noList':!floor.list}">
                                                            <template v-if="floor.list">
                                                                <div class="li" @click.stop="floorShowFun(floor,floor.list.length>0)">
                                                                    <el-checkbox :label="floor.id" :key="floor.id" :indeterminate="isIndeterminateTkf[item.id+'_'+build.id+'_'+floor.id]">{{floor.name}}</el-checkbox>
                                                                    <i class="iconfont icon-xiala" v-if="floor.list.length>0"></i>
                                                                </div>
                                                                <el-checkbox-group v-model="roomCheckListData[item.id+'_'+build.id+'_'+floor.id]" @change="roomCheckListChange(roomCheckListData[item.id+'_'+build.id+'_'+floor.id],item.id+'_'+build.id,floor.id,floor.list,item.id+'_'+build.id+'_'+floor.id)">
                                                                    <div v-for="room in floor.list" :key="room.id" class="room_box">
                                                                        <div class="li">
                                                                            <el-checkbox :label="room.id" :key="room.id">{{room.name}}</el-checkbox>
                                                                        </div>
                                                                    </div>
                                                                </el-checkbox-group>
                                                            </template>
                                                            <template v-if="!floor.list">
                                                                <div class="li" >
                                                                    <el-checkbox :label="floor.id" :key="floor.id" :indeterminate="isIndeterminateTkf[item.id+'_'+build.id+'_'+floor.id]">{{floor.name}}</el-checkbox>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </el-checkbox-group>
                                                </template>
                                                <template v-if="!build.list">
                                                    <div class="li">
                                                        <el-checkbox :label="build.id" :key="build.id" :indeterminate="isIndeterminateTkb[item.id+'_'+build.id]">{{build.name}}</el-checkbox>
                                                    </div>
                                                </template>
                                            </div>
                                        </el-checkbox-group>
                                    </template>
                                </div>
                            </el-checkbox-group>
                            <div class="bg_box">
                                <div v-for="item in userPermissionList" :key="item.id" class="hotel_box bg" :class="{'noShow':item.show}">
                                    <template v-if="item.list">
                                        <div class="li"></div>
                                        <div v-for="(build,x) in item.list" :key="build.id" class="build_box" :class="{'noShow':build.show,'noList':!build.list}">
                                            <template v-if="build.list">
                                                <div class="bg"></div>
                                                <div class="bg_b" v-if="build.list.length>0&&!build.show&&(x<item.list.length-1)"></div>
                                                <div class="li"></div>
                                                <div v-for="(floor,y) in build.list" :key="floor.id" class="floor_box" :class="{'noShow':floor.show,'noList':!floor.list}">
                                                    <template v-if="floor.list">
                                                        <div class="bg">
                                                        </div>
                                                        <div class="bg_b" v-if="floor.list.length>0&&!floor.show&&(y<build.list.length-1)"></div>
                                                        <div class="li"></div>
                                                        <div v-for="room in floor.list" :key="room.id" class="room_box">
                                                            <div class="bg"></div>
                                                            <div class="li"></div>
                                                        </div>
                                                    </template>
                                                    <template v-if="!floor.list">
                                                        <div class="bg"></div>
                                                        <div class="li"></div>
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-if="!build.list">
                                                <div class="bg"></div>
                                                <div class="li"></div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="setUserPermission()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">

    import { mapGetters } from 'vuex'
    import allUrl from '../../api/allUrl.js'
    import base from '../../api/base.js'

	export default {
		name:'maintenanceStaff',
		data () {
			return{
                userId:'',
                userNav:[],
                keywords:'',

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                repairArr:[],
                repairDataList:[],
                repairDataIdList:[],
                maintenanceStatusArr:['Maintenance','Repaired','No maintenance'],

                currentPage:1,
                pageSize:20,
                total:0,

                maintenanceStaffTkTitle:'',
                maintenanceStaffTkShowbg:false,
                maintenanceStaffTkShow:false,
                maintenanceStaffForm:{
                    name:'',
                    number:'',
                    phone:'',
                    email:'',
                },
                maintenanceStaffId:'',

                jurisdictionTkShowbg:false,
                jurisdictionTkShow:false,

                treeLAll:false,
                treeLAllIndeterminate:false,
                hotelCheckList:[],
                hotelCheckListR:[],
                buildCheckListData:{},
                buildCheckListData_:{},
                buildCheckListDataLength:[],
                floorCheckListData:{},
                floorCheckListData_:{},
                floorCheckListDataLength:[],
                roomCheckListData:{},
                roomCheckListData_:{},
                isIndeterminateTku:{},
                isIndeterminateTkb:{},
                isIndeterminateTkf:{},

                userPermissionList:[],
                userPermissionList_:[],
                userPermissionListR:[],

				loading:{
				},

                img_newMaintenanceStaff:'',
			}
		},
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
            }),
        },
		components:{
			// 'sideBar':sideBar
		},
		mounted(){
            this.img_newMaintenanceStaff = require('../../img/newMaintenanceStaff.png');
            if(this.version == '1'){
                this.img_newMaintenanceStaff = require('../../img/newMaintenanceStaff_v1.png');
            }

            this.maintenanceStatusArr = [this.$t('App.service.text16'),this.$t('App.service.text17'),this.$t('App.service.text15')];

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:false,
            })

            this.repairArr = [
                {prop:'name',label:this.$t('App.name'),minWidth:70},
                {prop:'id',label:this.$t('App.id'),minWidth:100},
                {prop:'phone',label:this.$t('App.service.text39'),minWidth:150},
                {prop:'email',label:this.$t('App.email'),minWidth:60},
                {prop:'hotelCount',label:this.$t('App.service.text40'),minWidth:150},
            ];

            this.getUserNav(()=>{
                if(this.userNav.length > 0){
                    this.userId = this.userNav[0].id;
                    this.getRepairList();
                }
            });
		},
		methods:{
			linkToFun(val){
				this.$router.push({path:val});
				this.$store.commit('ROUTERSTRFUN',{
					routerStr:val,
				})
			},
            /*用户下拉列表*/
            getUserNav(callback){
                base.ajax_post(
                    allUrl.userManagement.userNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.userNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            jurisdictionFun(obj){
                this.maintenanceStaffId = obj.id;
                this.jurisdictionTkShowbg = true;
                this.$nextTick(function(){
                    this.jurisdictionTkShow = true;
                    base.ajax_post(
                        allUrl.service.repairAuthList,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:obj.id,
                        },
                        {},
                        data=>{
                            this.$set(this,'userPermissionList',data.data.list);
                            for(let d of this.userPermissionList){
                                if(d.type != 3){
                                    this.$set(d,'select',0)
                                }
                                if(d.list){
                                    for(let dd of d.list){
                                        if(dd.type != 3){
                                            this.$set(dd,'select',0)
                                        }
                                        if(dd.list){
                                            for(let ddd of dd.list){
                                                if(ddd.type != 3){
                                                    this.$set(ddd,'select',0)
                                                }
                                                if(ddd.list){
                                                    for(let dddd of ddd.list){
                                                        if(dddd.select == '1'){
                                                            this.$set(d,'select',1)
                                                            this.$set(dd,'select',1)
                                                            this.$set(ddd,'select',1)
                                                            console.log(d)
                                                        }
                                                    }
                                                }else{
                                                    if(ddd.select == '1'){
                                                        this.$set(d,'select',1)
                                                        this.$set(dd,'select',1)
                                                    }
                                                }
                                            }
                                        }else{
                                            if(dd.select == '1'){
                                                this.$set(d,'select',1)
                                            }
                                        }
                                    }
                                }
                            }
                            this.hotelCheckList = [];
                            this.hotelCheckListR = [];
                            this.userPermissionList_ = [];
                            // let dIndex = 0;
                            let ddIndex = 0;
                            let dddIndex = 0;
                            let ddddIndex = 10;
                            for(let d of this.userPermissionList){
                                this.$set(this.isIndeterminateTku,d.id,false);
                                this.$set(this.buildCheckListData,d.id,[]);
                                this.$set(this.buildCheckListData_,d.id,[]);
                                this.$set(d,'show',false)
                                this.$set(this.buildCheckListDataLength,d.id,0);
                                if(d.select == 1){
                                    this.hotelCheckList.push(d.id)
                                    this.hotelCheckListR.push(d.id)
                                    this.userPermissionList_.push(d.id)

                                    if(d.list){
                                        if(d.list.length >0){
                                            this.isIndeterminateTku[d.id] = true;
                                        }
                                    }
                                }
                                // dIndex++;
                                ddIndex = 0;
                                if(d.list){
                                    for(let dd of d.list){
                                        this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false);
                                        this.$set(this.floorCheckListData,d.id+'_'+dd.id,[]);
                                        this.$set(this.floorCheckListData_,d.id+'_'+dd.id,[]);
                                        this.$set(dd,'show',false)
                                        this.$set(this.floorCheckListDataLength,dd.id,0);
                                        this.buildCheckListDataLength[d.id]++;
                                        if(dd.select == 1){
                                            this.buildCheckListData[d.id].push(dd.id)
                                            this.buildCheckListData_[d.id].push(dd.id)
                                            if(dd.list){
                                                if(dd.list.length >0){
                                                    this.isIndeterminateTkb[d.id+'_'+dd.id] = true;
                                                }
                                            }
                                        }else{
                                            if(this.hotelCheckList.indexOf(d.id) != -1){
                                                this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1);
                                                this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1);
                                                this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1);
                                            }
                                        }
                                        ddIndex++;
                                        dddIndex = 0;
                                        if(ddIndex == d.list.length){
                                            if(this.buildCheckListData[d.id].length == d.list.length){
                                                this.isIndeterminateTku[d.id] = false;
                                            }
                                            if(this.hotelCheckList.indexOf(d.id) != -1&&this.isIndeterminateTku[d.id]&&this.buildCheckListData[d.id].length!=0){
                                                this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1);
                                                this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1);
                                                this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1);
                                            }
                                        }

                                        if(dd.list){
                                            for(let ddd of dd.list){
                                                this.$set(this.isIndeterminateTkf,d.id+'_'+dd.id+'_'+ddd.id,false);
                                                this.$set(this.roomCheckListData,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                                this.$set(this.roomCheckListData_,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                                this.floorCheckListDataLength[dd.id]++;
                                                this.$set(ddd,'show',false)
                                                if(ddd.select == 1){
                                                    this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id)
                                                    this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id)

                                                    if(ddd.list){
                                                        if(ddd.list.length >0){
                                                            this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = true;
                                                        }
                                                    }
                                                }
                                                dddIndex++;
                                                ddddIndex = 0;

                                                if(dddIndex == dd.list.length){
                                                    if(this.floorCheckListData[d.id+'_'+dd.id].length == dd.list.length){
                                                        this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                                                    }
                                                }
                                                if(ddd.list){
                                                    if(dddIndex == dd.list.length){
                                                        console.log()
                                                        if(this.buildCheckListData[d.id].indexOf(dd.id) != -1&&this.isIndeterminateTkb[d.id+'_'+dd.id]&&this.floorCheckListData[d.id+'_'+dd.id].length!=0){
                                                            this.buildCheckListData[d.id].splice(this.buildCheckListData[d.id].indexOf(dd.id),1);
                                                            this.buildCheckListData_[d.id].splice(this.buildCheckListData_[d.id].indexOf(dd.id),1);
                                                        }
                                                    }
                                                    for(let dddd of ddd.list){
                                                        this.$set(dddd,'show',false)
                                                        if(dddd.select == 1){
                                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                        }
                                                        ddddIndex++
                                                        if(ddddIndex == ddd.list.length){
                                                            if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].length == ddd.list.length){
                                                                this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                                            }
                                                            if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) != -1&&this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id]&&this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].length!=0){
                                                                this.floorCheckListData[d.id+'_'+dd.id].splice(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id),1);
                                                                this.floorCheckListData_[d.id+'_'+dd.id].splice(this.floorCheckListData_[d.id+'_'+dd.id].indexOf(ddd.id),1);
                                                            }
                                                            
                                                        }
                                                    }
                                                }
                                                
                                            }
                                        }
                                    }
                                }
                            }
                        },
                    this)
                })
            },
            /*编辑用户权限*/
            setUserPermission(){
                let hotels = '';
                for(let d of this.userPermissionList){
                    if(d.select == 1&&d.type == '3'){
                        if(hotels == ''){
                            hotels = d.id;
                        }else{
                            hotels = hotels+','+d.id;
                        }
                    }
                    if(d.list){
                        for(let dd of d.list){
                            if(dd.select == 1&&dd.type == '3'){
                                if(hotels == ''){
                                    hotels = dd.id;
                                }else{
                                    hotels = hotels+','+dd.id;
                                }
                            }
                            if(dd.list){
                                for(let ddd of dd.list){
                                    if(ddd.select == 1&&ddd.type == '3'){
                                        if(hotels == ''){
                                            hotels = ddd.id;
                                        }else{
                                            hotels = hotels+','+ddd.id;
                                        }
                                    }
                                    if(ddd.list){
                                        for(let dddd of ddd.list){
                                            if(dddd.select == 1&&dddd.type == '3'){
                                                if(hotels == ''){
                                                    hotels = dddd.id;
                                                }else{
                                                    hotels = hotels+','+dddd.id;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                base.ajax_post(
                    allUrl.service.setRepairAuth,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.maintenanceStaffId,
                        hotels:hotels,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });

                        this.jurisdictionTkShow = false;
                        this.$nextTick(function(){
                            this.jurisdictionTkShowbg = false;
                        })
                    },
                    this
                )
            },
            jurisdictionTkClose(){
                let this_ = this;
                this.jurisdictionTkShow = false;
                setTimeout(function(){
                    this_.jurisdictionTkShowbg = false;
                },400)
            },

            hotelCheckListChange(arr){
                let type = arr.length>this.userPermissionList_.length?'add':'del';
                let arr1 = arr.length>this.userPermissionList_.length?arr:this.userPermissionList_;
                let arr2 = arr.length<this.userPermissionList_.length?arr:this.userPermissionList_;
                let hotelId = '';
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        hotelId = val;
                    }
                }
                this.hotelCheckListR = JSON.parse(JSON.stringify(arr));
                this.userPermissionList_ = JSON.parse(JSON.stringify(arr));
                for(let d of this.userPermissionList){
                    if(d.id == hotelId){
                        console.log(d)
                        this.isIndeterminateTku[d.id] = false;
                        if(type == 'add'){
                            d.select = 1;
                            if(d.list){
                                for(let dd of d.list){
                                    if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                        this.buildCheckListData[d.id].push(dd.id)
                                        this.buildCheckListData_[d.id].push(dd.id)
                                        dd.select = 1;
                                    }
                                    if(dd.list){
                                        for(let ddd of dd.list){
                                            if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) == -1){
                                                this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id)
                                                this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id)
                                                ddd.select = 1;
                                            }
                                            if(ddd.list){
                                                for(let dddd of ddd.list){
                                                    dddd.select = 1;
                                                    if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                                        this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                        this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }else{
                            d.select = 0;
                            this.isIndeterminateTku[d.id] = false;
                            this.buildCheckListData[d.id] = [];
                            this.buildCheckListData_[d.id] = [];
                            if(d.list){
                                for(let dd of d.list){
                                    dd.select = 0;
                                    this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                                    this.floorCheckListData[d.id+'_'+dd.id] = [];
                                    this.floorCheckListData_[d.id+'_'+dd.id] = [];
                                    if(dd.list){
                                        for(let ddd of dd.list){
                                            ddd.select = 0;
                                            if(ddd.list){
                                                for(let dddd of ddd.list){
                                                    dddd.select = 0;
                                                }
                                            }
                                            this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if(hotelId == ''){
                        d.select = 0;
                        this.isIndeterminateTku[d.id] = false;
                        this.buildCheckListData[d.id] = [];
                        this.buildCheckListData_[d.id] = [];
                        if(d.list){
                            for(let dd of d.list){
                                dd.select = 0;
                                this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                                this.floorCheckListData[d.id+'_'+dd.id] = [];
                                this.floorCheckListData_[d.id+'_'+dd.id] = [];
                                if(dd.list){
                                    for(let ddd of dd.list){
                                        ddd.select = 0;
                                        if(ddd.list){
                                            for(let dddd of ddd.list){
                                                dddd.select = 0;
                                            }
                                        }
                                        this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                        this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                        this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                    }
                                }
                            }
                        }
                    }
                }
            },
            buildCheckListChange(arr,id,list,userKey){
                let type = arr.length>this.buildCheckListData_[id].length?'add':'del';
                console.log(arr,this.buildCheckListData_[id])
                let arr1 = arr.length>this.buildCheckListData_[id].length?arr:this.buildCheckListData_[id];
                let arr2 = arr.length<this.buildCheckListData_[id].length?arr:this.buildCheckListData_[id];
                let buildId,isTrueFloor = true;
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        buildId = val;
                    }
                }
                this.buildCheckListData_[id] = JSON.parse(JSON.stringify(arr));
                if(arr.length == list.length){
                    if(this.hotelCheckList.indexOf(id) == -1){
                        this.hotelCheckList.push(id)
                        this.hotelCheckListR.push(id)
                        this.userPermissionList_.push(id)
                    }
                }else{
                    if(this.hotelCheckList.indexOf(id) != -1){
                        this.hotelCheckList.splice(this.hotelCheckList.indexOf(id),1)
                        this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(id),1)
                        this.userPermissionList_.splice(this.userPermissionList_.indexOf(id),1)
                    }
                }
                this.isIndeterminateTku[userKey] = arr.length > 0 && arr.length < list.length;
                for(let d of this.userPermissionList){
                    if(d.id == id){
                        if(d.list){
                            for(let dd of d.list){
                                console.log(buildId,dd.id,'---2---',type)
                                if(buildId == dd.id){
                                    this.isIndeterminateTkb[d.id+'_'+dd.id] = false;
                                    if(type == 'add'){
                                        dd.select = 1;
                                        if(dd.list){
                                            for(let ddd of dd.list){
                                                ddd.select = 1;
                                                if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) == -1){
                                                    this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id)
                                                    this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id)
                                                }
                                                if(ddd.list){
                                                    for(let dddd of ddd.list){
                                                        if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                                            dddd.select = 1;
                                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }else{
                                        console.log(dd,'----1--')
                                        dd.select = 0;
                                        this.floorCheckListData[d.id+'_'+dd.id] = [];
                                        this.floorCheckListData_[d.id+'_'+dd.id] = [];
                                        if(dd.list){
                                            for(let ddd of dd.list){
                                                ddd.select = 0;
                                                this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                                this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                                this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                                if(ddd.list){
                                                    for(let dddd of ddd.list){
                                                        dddd.select = 0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    // console.log(this.buildCheckListData[d.id].length,this.buildCheckListData[d.id].length,d.list.length,)
                                    if(this.buildCheckListData[d.id].length > 0 && this.buildCheckListData[d.id].length < d.list.length){
                                            this.$set(this.isIndeterminateTku,d.id,true)
                                            d.select = 1;
                                    }else{
                                        if(this.buildCheckListData[d.id].length == d.list.length){
                                            d.select = 1;
                                        }else{
                                            d.select = 0;
                                            if(this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                                this.$set(this.isIndeterminateTku,d.id,true)
                                                d.select = 1;
                                            }else{
                                                for(let key in this.isIndeterminateTkb){
                                                    if(this.isIndeterminateTkb[key]&&key.split('_')[0]==d.id){
                                                        isTrueFloor = false
                                                    }
                                                }
                                                console.log(this.isIndeterminateTkb,isTrueFloor)
                                                if(isTrueFloor){
                                                    d.select = 0;
                                                    this.$set(this.isIndeterminateTku,d.id,false)
                                                }else{
                                                    d.select = 1;
                                                    this.$set(this.isIndeterminateTku,d.id,true)
                                                }
                                            }
                                        }
                                    }
                                    if(arr.length != 0){
                                        return
                                    }
                                }
                                if(!buildId){
                                    dd.select = 0;
                                    this.floorCheckListData[d.id+'_'+dd.id] = [];
                                    this.floorCheckListData_[d.id+'_'+dd.id] = [];
                                    if(dd.list){
                                        for(let ddd of dd.list){
                                            ddd.select = 0;
                                            this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                            if(ddd.list){
                                                for(let dddd of ddd.list){
                                                    dddd.select = 0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                for(let d of this.userPermissionList){
                    if(arr.length == 0){
                        if(d.id == id&&this.buildCheckListData[d.id].length==0&&!this.isIndeterminateTku[d.id]){
                            d.select = 0;
                            return
                        }
                    }
                }
            },
            floorCheckListChange(arr,parentId,id,list,buildKey){
                let type = arr.length>this.floorCheckListData_[buildKey].length?'add':'del';
                let arr1 = arr.length>this.floorCheckListData_[buildKey].length?arr:this.floorCheckListData_[buildKey];
                let arr2 = arr.length<this.floorCheckListData_[buildKey].length?arr:this.floorCheckListData_[buildKey];
                let floorId,isTrueFloor = true;
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        floorId = val;
                    }
                }
                console.log(arr,arr1,arr2,floorId)
                this.floorCheckListData_[buildKey] = JSON.parse(JSON.stringify(arr));
                if(arr.length == list.length){
                    if(this.buildCheckListData[parentId].indexOf(id) == -1){
                        this.buildCheckListData[parentId].push(id)
                        this.buildCheckListData_[parentId].push(id)
                    }
                }else{
                    if(this.buildCheckListData[parentId].indexOf(id) != -1){
                        this.buildCheckListData[parentId].splice(this.buildCheckListData[parentId].indexOf(id),1)
                        this.buildCheckListData_[parentId].splice(this.buildCheckListData_[parentId].indexOf(id),1)
                    }
                }
                this.isIndeterminateTkb[buildKey] = arr.length > 0 && arr.length < list.length;
                for(let d of this.userPermissionList){
                    if(d.list){
                        for(let dd of d.list){
                            if(dd.list){
                                for(let ddd of dd.list){
                                    if(floorId == ddd.id){
                                        this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id] = false;
                                        if(type == 'add'){
                                            ddd.select = 1;
                                            console.log(ddd)
                                            if(ddd.list){
                                                for(let dddd of ddd.list){
                                                    if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                                        dddd.select = 1;
                                                        this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                        this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                    }
                                                }
                                            }
                                            if(this.floorCheckListData[d.id+'_'+dd.id].length > 0 && this.floorCheckListData[d.id+'_'+dd.id].length < dd.list.length){
                                                dd.select = 1;
                                            }else{
                                                if(this.floorCheckListData[d.id+'_'+dd.id].length == dd.list.length){
                                                    if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                                        dd.select = 1;
                                                    }
                                                }else{
                                                    if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                                        dd.select = 0;
                                                    }
                                                }
                                                if(this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id]){
                                                    dd.select = 1;
                                                }
                                            }
                                            console.log(dd)
                                        }else{
                                            ddd.select = 0;
                                            if(ddd.list){
                                                for(let dddd of ddd.list){
                                                    dddd.select = 0;
                                                }
                                            }
                                            this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                            this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                        }

                                        if(this.floorCheckListData[d.id+'_'+dd.id].length > 0 && this.floorCheckListData[d.id+'_'+dd.id].length < dd.list.length){
                                            this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                            dd.select = 1;
                                        }else{
                                            if(this.floorCheckListData[d.id+'_'+dd.id].length == dd.list.length){
                                                if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                                    dd.select = 1;
                                                    this.buildCheckListData[d.id].push(dd.id)
                                                    this.buildCheckListData_[d.id].push(dd.id)
                                                }
                                            }else{
                                                if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                                    dd.select = 0;
                                                    this.buildCheckListData[d.id].splice(this.buildCheckListData[d.id].indexOf(dd.id),1)
                                                    this.buildCheckListData_[d.id].splice(this.buildCheckListData_[d.id].indexOf(dd.id),1)
                                                }
                                                let isTkbTrue = false;
                                                for(let ddd_ of dd.list){
                                                    if(this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd_.id]){
                                                        isTkbTrue = true
                                                    }
                                                }
                                                if(isTkbTrue){
                                                    this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                                }
                                            }
                                            if(this.isIndeterminateTkf[d.id+'_'+dd.id+'_'+ddd.id]){
                                                this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                                dd.select = 1;
                                            }else{
                                                for(let key in this.isIndeterminateTkf){
                                                    if(this.isIndeterminateTkf[key]){
                                                        isTrueFloor = false
                                                    }
                                                }
                                                if(isTrueFloor){
                                                    this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false)
                                                }
                                            }
                                        }

                                        if(this.buildCheckListData[parentId].length > 0 && this.buildCheckListData[parentId].length < d.list.length){
                                            this.$set(this.isIndeterminateTku,parentId,true)
                                            d.select = 1;
                                        }else{
                                            if(this.isIndeterminateTkb[parentId+'_'+id]){
                                                this.$set(this.isIndeterminateTku,parentId,true)
                                                d.select = 1;
                                            }else{
                                                for(let key in this.isIndeterminateTkb){
                                                    if(this.isIndeterminateTkb[key]){
                                                        isTrueFloor = false
                                                    }
                                                }
                                                if(isTrueFloor){
                                                    d.select = 0;
                                                    this.$set(this.isIndeterminateTku,parentId,false)
                                                }else{
                                                    d.select = 1;
                                                }
                                                
                                                // d.select = 1;
                                            }
                                            if(this.buildCheckListData[parentId].length == d.list.length){
                                                if(this.hotelCheckList.indexOf(d.id) == -1){
                                                    this.hotelCheckList.push(d.id)
                                                    this.hotelCheckListR.push(d.id)
                                                    this.userPermissionList_.push(d.id)
                                                    d.select = 1;
                                                }
                                            }else{
                                                if(this.hotelCheckList.indexOf(d.id) != -1){
                                                    this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1)
                                                    this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1)
                                                    this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1)
                                                    // d.select = 0;
                                                }
                                            }

                                        }
                                        if(arr.length != 0){
                                            return
                                        }
                                    }
                                    if(!floorId){
                                        ddd.select = 0;
                                        if(ddd.list){
                                            for(let dddd of ddd.list){
                                                dddd.select = 0;
                                            }
                                        }
                                        this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                        this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id] = [];
                                    }
                                }
                            }
                        }
                    }
                }
                for(let d of this.userPermissionList){
                    if(arr.length == 0){
                        console.log(d.id,buildKey.split('_')[0],this.buildCheckListData[d.id].length,this.isIndeterminateTku[d.id])
                        if(d.id == buildKey.split('_')[0]){
                            if(this.buildCheckListData[d.id].length==0&&!this.isIndeterminateTku[d.id]){
                                d.select = 0;
                            }
                            if(d.list){
                                for(let dd of d.list){
                                    if(dd.id == buildKey.split('_')[1]){
                                        if(this.floorCheckListData[d.id+'_'+dd.id].length==0&&!this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                            dd.select = 0;
                                        }
                                        return
                                    }
                                }
                            }
                        }
                    }
                }
            },
            roomCheckListChange(arr,parentId,id,list,floorKey){
                let type = arr.length>this.roomCheckListData_[floorKey].length?'add':'del';
                let arr1 = arr.length>this.roomCheckListData_[floorKey].length?arr:this.roomCheckListData_[floorKey];
                let arr2 = arr.length<this.roomCheckListData_[floorKey].length?arr:this.roomCheckListData_[floorKey];
                let roomId,isTrueFloor = true;
                for(let val of arr1){
                    if(arr2.indexOf(val) == -1){
                        roomId = val;
                    }
                }
                console.log(arr1,arr2,roomId,type)
                this.roomCheckListData_[floorKey] = JSON.parse(JSON.stringify(arr));
                if(arr.length == list.length){
                    if(this.floorCheckListData[parentId].indexOf(id) == -1){
                        this.floorCheckListData[parentId].push(id)
                        this.floorCheckListData_[parentId].push(id)
                    }
                }else{
                    if(this.floorCheckListData[parentId].indexOf(id) != -1){
                        this.floorCheckListData[parentId].splice(this.floorCheckListData[parentId].indexOf(id),1)
                        this.floorCheckListData_[parentId].splice(this.floorCheckListData[parentId].indexOf(id),1)
                    }
                }
                this.$set(this.isIndeterminateTkf,floorKey,arr.length > 0 && arr.length < list.length)
                for(let d of this.userPermissionList){
                    if(d.list){
                        for(let dd of d.list){
                            if(dd.list){
                                for(let ddd of dd.list){
                                    if(ddd.list){
                                        for(let dddd of ddd.list){
                                            if(roomId == dddd.id){
                                                if(type == 'add'){
                                                    dddd.select = 1;
                                                    ddd.select = 1;
                                                    dd.select = 1;
                                                    d.select = 1;
                                                }else{
                                                    dddd.select = 0;
                                                }
                                                if(this.roomCheckListData[floorKey].length > 0 && this.roomCheckListData[floorKey].length < ddd.list.length){
                                                    ddd.select = 1;
                                                }else{
                                                    if(this.roomCheckListData[floorKey].length == ddd.list.length){
                                                        ddd.select = 1;
                                                    }else{
                                                        ddd.select = 0;
                                                    }
                                                }
                                                if(this.floorCheckListData[parentId].length > 0 && this.floorCheckListData[parentId].length < dd.list.length){
                                                    this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,true)
                                                    dd.select = 1;
                                                }else{
                                                    if(this.floorCheckListData[parentId].length == dd.list.length){
                                                        if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                                            dd.select = 1;
                                                            this.buildCheckListData[d.id].push(dd.id)
                                                            this.buildCheckListData_[d.id].push(dd.id)
                                                        }
                                                    }else{
                                                        if(this.buildCheckListData[d.id].indexOf(dd.id) != -1){
                                                            dd.select = 0;
                                                            this.buildCheckListData[d.id].splice(this.buildCheckListData[d.id].indexOf(dd.id),1)
                                                            this.buildCheckListData_[d.id].splice(this.buildCheckListData_[d.id].indexOf(dd.id),1)
                                                        }
                                                    }
                                                    if(this.isIndeterminateTkf[floorKey]){
                                                        this.$set(this.isIndeterminateTkb,floorKey.split('_')[0]+'_'+floorKey.split('_')[1],true)
                                                        dd.select = 1;
                                                    }else{
                                                        for(let key in this.isIndeterminateTkf){
                                                            if(this.isIndeterminateTkf[key]){
                                                                isTrueFloor = false
                                                            }
                                                        }
                                                        if(isTrueFloor){
                                                            this.$set(this.isIndeterminateTkb,floorKey.split('_')[0]+'_'+floorKey.split('_')[1],false)
                                                        }
                                                    }
                                                }

                                                console.log(this.floorCheckListData[parentId].length,dd.list.length,dd.list.length,dd,this.buildCheckListData[d.id].indexOf(dd.id))

                                                if(this.buildCheckListData[d.id].length > 0 && this.buildCheckListData[d.id].length < d.list.length){
                                                    this.$set(this.isIndeterminateTku,d.id,true)
                                                    d.select = 1;
                                                }else{
                                                    if(this.buildCheckListData[d.id].length == d.list.length){
                                                        if(this.hotelCheckList.indexOf(d.id) == -1){
                                                            this.hotelCheckList.push(d.id)
                                                            this.hotelCheckListR.push(d.id)
                                                            this.userPermissionList_.push(d.id)
                                                            d.select = 1;
                                                        }
                                                    }else{
                                                        if(this.hotelCheckList.indexOf(d.id) != -1){
                                                            this.hotelCheckList.splice(this.hotelCheckList.indexOf(d.id),1)
                                                            this.hotelCheckListR.splice(this.hotelCheckListR.indexOf(d.id),1)
                                                            this.userPermissionList_.splice(this.userPermissionList_.indexOf(d.id),1)
                                                            d.select = 0;
                                                        }
                                                    }
                                                    if(this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                                        this.$set(this.isIndeterminateTku,d.id,true)
                                                        d.select = 1;
                                                    }else{
                                                        this.$set(this.isIndeterminateTku,d.id,false)
                                                        // if(this.hotelCheckList.indexOf(d.id) != -1){
                                                        //     d.select = 0;
                                                        // }
                                                    }
                                                    
                                                }
                                                if(arr.length != 0){
                                                    return
                                                }
                                            }
                                            if(!roomId){
                                                dddd.select = 0;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                for(let d of this.userPermissionList){
                    if(arr.length == 0){
                        console.log(d.id,floorKey.split('_')[0],this.buildCheckListData[d.id].length,this.isIndeterminateTku[d.id])
                        if(d.id == floorKey.split('_')[0]){
                            if(this.buildCheckListData[d.id].length==0&&!this.isIndeterminateTku[d.id]){
                                d.select = 0;
                            }
                            if(d.list){
                                for(let dd of d.list){
                                    if(dd.id == floorKey.split('_')[1]){
                                        console.log(dd,this.floorCheckListData[d.id+'_'+dd.id].length,this.isIndeterminateTkb[d.id+'_'+dd.id])
                                        if(this.floorCheckListData[d.id+'_'+dd.id].length==0&&!this.isIndeterminateTkb[d.id+'_'+dd.id]){
                                            dd.select = 0;
                                        }
                                        return
                                    }
                                }
                            }
                        }
                    }
                }
            },
            hotelShowFun(data,isTrue){
                if(isTrue){
                    if(data.show){
                        data.show = false;
                    }else{
                        data.show = true;
                    }
                }
            },
            buildShowFun(data,isTrue){
                if(isTrue){
                    if(data.show){
                        data.show = false;
                    }else{
                        data.show = true;
                    }
                }
            },
            floorShowFun(data,isTrue){
                if(isTrue){
                    if(data.show){
                        data.show = false;
                    }else{
                        data.show = true;
                    }
                }
            },
            treeLAllChange(val){
                this.$set(this,'hotelCheckList',[])
                this.$set(this,'hotelCheckListR',[])
                this.$set(this,'userPermissionList_',[])
                if(val){
                    for(let d of this.userPermissionList){
                        if(this.hotelCheckList.indexOf(d.id) == -1){
                            this.hotelCheckList.push(d.id)
                            this.hotelCheckListR.push(d.id)
                            this.userPermissionList_.push(d.id)
                        }
                        d.select = 1;
                        this.$set(this.isIndeterminateTku,d.id,false);
                        if(d.list){
                            for(let dd of d.list){
                                if(this.buildCheckListData[d.id].indexOf(dd.id) == -1){
                                    this.buildCheckListData[d.id].push(dd.id);
                                    this.buildCheckListData_[d.id].push(dd.id);
                                }
                                dd.select = 1;
                                this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false);
                                if(dd.list){
                                    for(let ddd of dd.list){
                                        if(this.floorCheckListData[d.id+'_'+dd.id].indexOf(ddd.id) == -1){
                                            this.floorCheckListData[d.id+'_'+dd.id].push(ddd.id);
                                            this.floorCheckListData_[d.id+'_'+dd.id].push(ddd.id);
                                        }
                                        ddd.select = 1;
                                        this.$set(this.isIndeterminateTkf,d.id+'_'+dd.id+'_'+ddd.id,false);
                                        if(ddd.list){
                                            for(let dddd of ddd.list){
                                                if(this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].indexOf(dddd.id) == -1){
                                                    this.roomCheckListData[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                    this.roomCheckListData_[d.id+'_'+dd.id+'_'+ddd.id].push(dddd.id)
                                                }
                                                dddd.select = 1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }else{
                    this.treeLAll = false;
                    for(let d of this.userPermissionList){
                        d.select = 0;
                        this.$set(this.isIndeterminateTku,d.id,false);
                        this.$set(this.buildCheckListData,d.id,[]);
                        this.$set(this.buildCheckListData_,d.id,[]);
                        if(d.list){
                            for(let dd of d.list){
                                dd.select = 0;
                                this.$set(this.isIndeterminateTkb,d.id+'_'+dd.id,false);
                                this.$set(this.floorCheckListData,d.id+'_'+dd.id,[]);
                                this.$set(this.floorCheckListData_,d.id+'_'+dd.id,[]);
                                if(dd.list){
                                    for(let ddd of dd.list){
                                        ddd.select = 0;
                                        this.$set(this.isIndeterminateTkf,d.id+'_'+dd.id+'_'+ddd.id,false);
                                        this.$set(this.roomCheckListData,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                        this.$set(this.roomCheckListData_,d.id+'_'+dd.id+'_'+ddd.id,[]);
                                        if(ddd.list){
                                            for(let dddd of ddd.list){
                                                dddd.select = 0;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            editInfo(data){
                this.maintenanceStaffTkTitle = this.$t('App.service.text36');
                this.maintenanceStaffTkShowbg = true;
                this.$nextTick(function(){
                    this.maintenanceStaffTkShow = true;
                })
                this.maintenanceStaffId = data.id;
                this.maintenanceStaffForm.name = data.name;
                this.maintenanceStaffForm.number = data.number;
                this.maintenanceStaffForm.phone = data.phone;
                this.maintenanceStaffForm.email = data.email;
            },
            /*添加编辑设备*/
            addMaintenanceStaffFun(){
                this.maintenanceStaffId = '';
                this.maintenanceStaffForm.name = '';
                this.maintenanceStaffForm.number = '';
                this.maintenanceStaffForm.phone = '';
                this.maintenanceStaffForm.email = '';
                this.maintenanceStaffTkTitle = this.$t('App.service.text35');
                this.maintenanceStaffTkShowbg = true;
                this.$nextTick(function(){
                    this.maintenanceStaffTkShow = true;
                })
            },
            maintenanceStaffTkClose(){
                let this_ = this;
                this.maintenanceStaffTkShow = false;
                setTimeout(function(){
                    this_.maintenanceStaffTkShowbg = false;
                },400)
            },
            postSaveMaintenanceStaff(){
                let this_ = this;
                base.ajax_post(
                    allUrl.service.saveRepair,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:this.maintenanceStaffId,
                        ...this.maintenanceStaffForm,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.maintenanceStaffTkShow = false;
                        setTimeout(function(){
                            this_.maintenanceStaffTkShowbg = false;
                        },400)
                        this.getRepairList();
                    },
                    this
                )
            },
            /*删除维修人员*/
            postDelRepair(obj,type){
                let repairId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(repairId == ''){
                                repairId = id;
                            }else{
                                repairId += ','+id;
                            }
                        }
                    }
                }else{
                    repairId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text28'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.service.delRepair,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                id:repairId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getRepairList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getRepairListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getRepairList();
                }
            },
            getRepairList(callback){
                base.ajax_post(
                    allUrl.service.repairGetList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        page:this.currentPage,
                        count:this.pageSize,
                        keywords:this.keywords,
                        // userId:this.userId,
                    },
                    {},
                    data=>{
                        this.repairDataList = data.data.list;
                        this.total = Number(data.data.total);

                        this.repairDataIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                        for(let d of this.repairDataList){
                            this.repairDataIdList.push(d.id);
                            this.$set(d,'brightness_',d.brightness*2);
                            this.$set(d,'color_',d.color*300+3000);
                            this.$set(d,'brightnessLoading',false);
                            this.$set(d,'colorLoading',false);
                        }

                        let i = 1 + (this.currentPage-1)*this.pageSize;
                        for(let d of this.repairDataList){
                            d.webIndex = i;
                            i++;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getRepairList();
                // console.log(val)
            },
            handleCheckAllChange(val) {
                this.checkList = val ? this.repairDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.repairDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.repairDataIdList.length;
            },
        },
        watch:{
            userId:function(){
                if(this.userId){
                    this.getRepairList();
                }
            },
        }
    }
</script>

<style type="text/css" lang="less">
    .maintenanceStaff_main{
		width: 100%;
		height: 100%;
		// height: 105rem;
		min-height: 50rem;
		// min-width: 120rem;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		background: #F6F8FA;
        &.cn{
            .maintenanceStaff_content{
                .toolbar .toolbar_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .table_box{
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .maintenanceStaff_wrap .maintenanceStaff_box{
                .btn_box .btn{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
            .jurisdiction_wrap{
                .tree_box .el-checkbox__input{
                    &.is-checked .el-checkbox__inner{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        border-color: rgba(0,0,0,0);
                    }
                    &.is-indeterminate .el-checkbox__inner{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        border-color: rgba(0,0,0,0);
                    }
                }
                .jurisdiction_box .btn_box .btn{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
        }
        .maintenanceStaff_top{
            display: flex;
            width: 100%;
            align-items: center;
            padding-left: 1rem;
            height: 2.67rem;
            background: #FFFFFF;
            box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
            .span1{
                font-size:1rem;
                font-family:AlibabaPuHuiTiR;
                color:rgba(51,51,51,1);
            }
            .span2{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #A3AFBB;
            }
            .box{
                margin-left: 1rem;
            }
            .btn{
                line-height: 2.67rem;
                cursor: pointer;
                .iconfont{
                    margin-right: 0.5rem;
                    font-size: 0.8rem;
                }
            }
        }
        .maintenanceStaff_content{
            height: calc(100% - 3rem);
            margin: 1.5rem 0;
            .toolbar{
                padding: 0 1.67rem;
                display: flex;
                justify-content: space-between;
                .toolbar_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 18rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
                .toolbar_r{
                    .btn{
                        margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.5rem;
                            height: 1rem;
                        }
                    }
                }
            }
            .table_box{
                height: calc(100% - 5.67rem);
                margin: 0.8rem 1.67rem 0;
                background-color:#fff;
                border: 1px solid rgba(240, 240, 240, 1);
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    height: 3.2rem;line-height: 3.2rem;
                    .main_top_l{
                        margin-left: 1.67rem;
                        display: flex;
                        .btn{
                            margin-left: 1.29rem;
                            display: flex;align-items: center;
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            i{
                                font-size:0.8rem;
                                color: #C6CDD5;
                            }
                            span{
                                margin-left: 0.5rem;
                            }
                        }
                    }
                }
                .el-checkbox-group{
                    height: calc(100% - 10rem);
                }
                .el-table{
                    .btn{
                        padding: 0.5rem;
                        cursor: pointer;
                        &+.btn{
                            margin-left: 0.2rem;
                        }
                        i{
                            color: #A3AFBB;
                            font-size:0.8rem;
                        }
                        &:hover{
                            i{
                                color: #05CFAB;
                            }
                        }
                    }
                    th{
                        font-weight:initial;
                        height: 3rem;
                        border-top: 1px solid #F0F0F0;
                        border-bottom: 1px solid #F0F0F0;
                        padding: 0;
                        background: #F6F8FA;
                        &>.cell{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                        }
                    }
                    td{
                        padding: 0;
                        height: 3rem;
                        &>.cell,.el-checkbox__label{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #657085;
                            }
                    }
                    .maintenanceStatus{
                        .text_1{
                            color: #05cfab;
                        }
                        .text_2{
                            color: #FF0C4D;
                        }
                    }
                }
                .pagination_box{
                    margin-top: 2rem;
                    height: 2.5rem;line-height: 2.5rem;
                    .el-pagination{
                        float: right;
                    }
                    .btn-prev .el-icon{
                        font-size:1rem;
                        color: #666666;
                        font-family: PingFang-SC-Medium;
                    }
                    button{
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: rgba(246, 248, 250, 1);
                        border-radius: 0.2rem;
                    }
                    .el-pager li{
                        margin-left: 0.83rem;
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: rgba(246, 248, 250, 1);
                        border-radius: 0.2rem;
                        &:hover{
                        color: rgba(62, 175, 55, 1);
                        background-color: rgba(62, 175, 55, 0.1);
                        }
                    }
                    .btn-next{
                        margin-left: 0.83rem;
                    }
                    .el-pager li.active{
                        background: rgba(62, 175, 55, 1);
                        color: #FFFFFF;
                    }
                }
            }
        }
        .maintenanceStaff_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .maintenanceStaff_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 30rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .maintenanceStaff_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 30rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.maintenanceStaff_tk_show{
                    right: 0rem; 
                }
                .maintenanceStaff_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .jurisdiction_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .jurisdiction_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .jurisdiction_box{
                position: absolute;
                width: 47rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.jurisdiction_tk_show{
                    right: 0rem; 
                }
                .jurisdiction_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
            .tree_box{
                display: flex;
                margin: 2.5rem 2.5rem 0;
                background: #F6F8F7;
                border: 1px solid #F0F0F0;
                height: calc(100% - 14rem);
                
                .el-checkbox__input{
                    &.is-checked,&.is-indeterminate{
                        .el-checkbox__inner{
                            background-color:rgba(5, 207, 171, 1);
                            border-color:rgba(5, 207, 171, 1);
                        }
                    }
                }
                .el-checkbox__inner{
                    width: 1.33rem;height: 1.33rem;
                    &::after{
                        width: 0.3rem;height: 0.6rem;
                        top:0.1rem;left: 0.4rem;
                        border: 0.15rem solid #FFF;
                        border-left: 0;
                        border-top: 0;
                    }
                    &::before{
                        height: 0.25rem;
                        top: 0.45rem;
                    }
                }
                .el-checkbox__label{
                    font-family: PingFang-SC-Medium;
                    font-size: 1.1rem;
                    color: #333333;
                }
                .t{
                    height: 3rem;line-height: 3rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 1rem;
                    border-bottom: 1px solid #F0F0F0;
                    background-color: #fff;
                    .label{
                        font-family: PingFang-SbtnC-Medium;
                        font-size: 1.1rem;
                        color: #333333;
                    }
                    .el-checkbox__label{
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #657085;
                    }
                    .btn{
                        padding: 0.5rem;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #657085;
                        span{
                            margin-left: 0.5rem;
                        }
                        i{
                            color: #A3AFBB;
                            font-size:0.8rem;
                        }
                    }
                }
                .b1,.b2{
                    height: calc(100% - 18rem);
                    border-bottom: 1px solid #F0F0F0;
                    position: relative;
                    .li{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        cursor: pointer;
                        padding-right: 1.2rem;
                        height: 2.5rem;line-height: 2.5rem;
                        .iconfont{
                            font-size:0.6rem;
                            color: #A0ACC2;
                            transition: all 0.5s;
                            transform:rotate(0deg);
                        }
                    }
                    .noShow .iconfont{
                        transform:rotate(180deg);
                    }
                    .bg_box{
                        position: absolute;
                        z-index: 0;
                        top: 0;left: 0;
                    }
                    .hotel_box{
                        margin-top: 1rem;
                        margin-left: 1.67rem;
                        // transition: all 1s;
                        overflow: hidden;
                        position: relative;
                        z-index: 1;
                        &.bg{
                            width: calc(100% - 1.67rem);
                            position: relative;
                            .build_box{
                                overflow: initial;
                                position: relative;
                                &.noShow{
                                    .floor_box{
                                        overflow: hidden;
                                    }
                                }
                                &:nth-child(3){
                                    >.bg{
                                        top: -1rem;
                                        width: 1rem;height: 2.3rem;
                                    }
                                }
                                &.noList{
                                    margin-left: 4.5rem;
                                    .bg{
                                        left: -4rem;width: 4rem;
                                    }
                                }
                                .floor_box{
                                    overflow: initial;
                                    position: relative;
                                    &.noShow{
                                        .room_box{
                                            overflow: hidden;
                                        }
                                    }
                                    &:nth-child(3){
                                        >.bg{
                                            top: -1rem;
                                            width: 1rem;height: 2.3rem;
                                        }
                                    }
                                    &.noList{
                                        margin-left: 3rem;
                                        &:nth-child(3){
                                            >.bg{
                                                width: 2.5rem;left: -2.5rem;
                                            }
                                        }
                                    }
                                    .room_box{
                                        overflow: initial;
                                        position: relative;
                                        &:nth-child(3){
                                            >.bg{
                                                top: -1rem;
                                                width: 1rem;height: 2.3rem;
                                            }
                                        }
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    top: -1.2rem;left: -1rem;
                                    width: 1rem;height: 2.5rem;
                                    border-left: 1px dashed #E1E5EA;
                                    border-bottom: 1px dashed #E1E5EA;
                                }
                                .bg_b{
                                    height: 100%;
                                    position: absolute;
                                    top: 0;left: -1rem;
                                    border-left: 1px dashed #E1E5EA;
                                }
                            }
                        }
                        &.noShow{
                            height: 2.5rem;
                        }
                        .build_box{
                            // margin-top: 0.5rem;
                            margin-left: 1.5rem;
                            overflow: hidden;
                            position: relative;
                            &.noShow{
                                height: 2.5rem;
                            }
                            &.noList{
                                margin-left: 4.5rem;
                            }
                            .floor_box{
                                margin-left: 1.5rem;
                                overflow: hidden;
                                &.noShow{
                                    height: 2.5rem;
                                }
                                &.noList{
                                    margin-left: 3rem;
                                }
                                .room_box{
                                    margin-left: 1.5rem;
                                }
                            }
                        }
                    }
                }
                .b2{
                    height: 15rem;
                }
                .left{
                    flex: 1;
                    border-right: 1px solid #F0F0F0;
                }
            }
        }
	}
</style>